import { useEffect, useMemo, useState } from 'react'

const normalizeValue = (value) => {
  if (value === undefined || value === null) {
    return ''
  }
  return String(value).trim().toLowerCase()
}

const toStableContextKey = (context = {}) => {
  return Object.entries(context)
    .filter(([, value]) => value !== undefined && value !== null && value !== '')
    .sort(([leftKey], [rightKey]) => leftKey.localeCompare(rightKey))
    .map(([key, value]) => `${key}=${normalizeValue(value)}`)
    .join('&')
}

const useAutocompleteRequestKey = ({
  query,
  context = {},
  debounceMs = 250,
  minLength = 2,
}) => {
  const normalizedQuery = useMemo(() => normalizeValue(query), [query])
  const contextKey = useMemo(() => toStableContextKey(context), [context])
  const [debouncedQuery, setDebouncedQuery] = useState(normalizedQuery)

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedQuery(normalizedQuery)
    }, debounceMs)

    return () => {
      clearTimeout(timeoutId)
    }
  }, [normalizedQuery, debounceMs])

  const requestKey = useMemo(() => {
    return `q=${debouncedQuery}|${contextKey}`
  }, [debouncedQuery, contextKey])

  return {
    debouncedQuery,
    requestKey,
    shouldFetchAutocomplete: debouncedQuery.length >= minLength,
  }
}

export default useAutocompleteRequestKey
